import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
// import _ from 'lodash';

import './style.scss'

export default class Link extends Component {
    static propTypes = {
        iconType: PropTypes.oneOf(['pdf', 'external']),
        label: PropTypes.string,
        openOnNewTab: PropTypes.bool,
        showIcon: PropTypes.bool,
        url: PropTypes.string,
    }

    static defaultProps = {
        showIcon: false,
        openOnNewTab: false,
        label: '',
        url: '',
    }

    render() {
        const { label, url, showIcon, openOnNewTab, iconType } = this.props

        return (
            <a
                href={url}
                className={classnames('table-cell-anchor-link', showIcon && `with-icon icon-${iconType}`)}
                target={openOnNewTab && '_blank'}
                rel="noopener noreferrer"
            >
                {label}
            </a>
        )
    }
}
